import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  ScrollBlockingService,
  SearchSubscriptionService,
} from '@immosky/shared';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { SearchSubscriptionAppParameters } from '../../services/search-subscription-app-parameters.service';
import { AppParametersService } from '@immosky/types';

@Component({
  selector: 'app-mobile-wizard',
  templateUrl: './mobile-wizard.component.html',
  styleUrls: ['./mobile-wizard.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileWizardComponent implements OnInit, OnDestroy {
  wasSuccessful = false;
  currentStepIndex = 0;

  @Output()
  requestClose = new EventEmitter();

  get canSubmit() {
    return this.searchSubscriptionService.isValid;
  }

  get objectSearchUrl(): string {
    return this.appParametersService.get().objectSearchUrl;
  }

  constructor(
    private appParametersService: AppParametersService<SearchSubscriptionAppParameters>,
    private searchSubscriptionService: SearchSubscriptionService,
    private scrollBlockingService: ScrollBlockingService
  ) {}

  ngOnInit(): void {
    this.scrollBlockingService.block();
  }

  ngOnDestroy(): void {
    this.scrollBlockingService.unblock();
  }

  submit() {
    this.searchSubscriptionService.submitSearchSubscription(
      this.appParametersService.get().countries[0]
    );
    this.wasSuccessful = true;
  }

  closeMobile() {
    this.requestClose.emit();
  }

  onStepperChange(event: StepperSelectionEvent) {
    this.currentStepIndex = event.selectedIndex;
  }

  goToPreviousStep() {
    this.currentStepIndex = 0;
  }
}
